import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "serp__filter--clear-button-container",
  class: "serp__filter--clear-button-container q-col-12 q-pb-1 q-text-center"
}

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {toRefs} from "vue";
import ClearFiltersButton from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButton.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'ClearFiltersButtonContainer',
  setup(__props) {

const filtersStore = useFiltersStore()
const {hasSelectedFilters} = toRefs(filtersStore)


return (_ctx: any,_cache: any) => {
  return (_unref(hasSelectedFilters))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ClearFiltersButton)
      ]))
    : _createCommentVNode("", true)
}
}

})